import { SYSTableDefIds } from "../../../../../../src"
let defId: SYSTableDefIds = undefined
let columnKey = ""
let additionalColumnKey = ""
let allowExclusive = true

export let columnFilter = {
  defId,
  columnKey,
  additionalColumnKey,
  allowExclusive,
}
